import React from 'react'
import styled from 'styled-components'
import RetailStores from '../finwhale/common/retail-stores'
import * as media from '../media'
import TranslateText from 'src/text/modal';
import CurrentLanguageContext from 'src/context/currentLanguageContext';


const Header = styled.div`
  margin: 40px;
  margin-left:0;
  margin-right:0;
  margin-bottom: 25px;
  font-size: 24px;
  font-weight: 800;
  ${media.smallerThan(700)`text-align: center;`}
`

const Description = styled.div`
  display: flex;
  margin: 40px;
  margin-right:0;
  margin-left:0;
  margin-top: 0;
  ${media.smallerThan(900)` flex-direction: column-reverse; align-items: center;`}
`

const A = styled.a`
  ${props => props.active
  ? 'background: #0054ff; color: #fff; cursor: auto;'
  : 'cursor: pointer; background: #fff; color: #0054ff; span { border-bottom: 1px dashed; } &:hover { color: red; }'
  }
  padding: 26px 34px 24px;
  padding-left: 0;
  padding-right: 0;
  padding-top: 10px; 
  text-decoration: none;
  display: inline-block;
  transition: all .3s ease;
`

const Container = styled.div`
  margin-top: 15px;
  ${media.smallerThan(700)` text-align:center;`}
`

const buy = ({finsalepoints, loading}) => (
  <div>

    <div dangerouslySetInnerHTML={{
      __html: `<!--
Start of Floodlight Tag: Please do not remove
Activity name of this tag: finwhale.ru_wtb
URL of the webpage where the tag is expected to be placed: 
This tag must be placed between the <body> and </body> tags, as close as possible to the opening tag.
Creation Date: 03/20/2019
-->
<script type="text/javascript">
var axel = Math.random() + "";
var a = axel * 10000000000000;
document.write('<iframe src="https://9257786.fls.doubleclick.net/activityi;src=9257786;type=invmedia;cat=finwh000;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;npa=;ord=[SessionID]?" width="1" height="1" frameborder="0" style="display:none"></iframe>');
</script>
<noscript>
<iframe src="https://9257786.fls.doubleclick.net/activityi;src=9257786;type=invmedia;cat=finwh000;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;npa=;ord=[SessionID]?" width="1" height="1" frameborder="0" style="display:none"></iframe>
</noscript>
<!-- End of Floodlight Tag: Please do not remove -->`
    }


    }/>
    <CurrentLanguageContext>
      {currentLanguage => {
        return (
          <div style={{width: '80%', margin: '0px auto'}}>
            <div>
              <Header>
                <TranslateText id="buy__header"/>
              </Header>

              <Description>
                <div
                  style={{
                    flexGrow: 1,
                    flexShrink: 1,
                  }}
                >
                  <Container>
                    <TranslateText id="buy__text"/>
                  </Container>
                  <Container>
                    <A
                      href={currentLanguage === 'en' ? 'mailto:info@finwhale.eu' : 'mailto:postavka@finwhale.ru'}
                    >
                      <TranslateText id="buy__write_to_us" />
                    </A>
                  </Container>
                </div>
              </Description>
            </div>

            <RetailStores/>

          </div>
        );
      }}
    </CurrentLanguageContext>
  </div>
)

export default buy



// WEBPACK FOOTER //
// ./src/pages/buy.js